export const beginSource = (source) => ({ type: 'beginSource', source });
export const activateSource = (source, symbols, now) => ({
    type: 'activateSource',
    source,
    symbols,
    now,
});
export const membershipReset = () => ({ type: 'membershipReset' });
export const activateSymbols = (symbols, now) => ({
    type: 'activateSymbols',
    symbols,
    now,
});
export const publishSymbols = (symbols, now) => ({
    type: 'publishSymbols',
    symbols,
    now,
});
export const setRetention = (retention, now) => ({ type: 'setRetention', retention, now });
export const cleanup = (now) => ({ type: 'cleanup', now });
export const measure = (measurement, cause = 'scroll') => ({
    type: 'measure',
    measurement,
    cause,
});
export const trim = (start, end, now) => ({ type: 'trim', start, end, now });
export const reconcileRound = (now) => ({ type: 'reconcileRound', now });
export const claim = (intent) => ({ type: 'claim', intent });
export const resolve = (ticket, result, now) => ({
    type: 'resolve',
    ticket,
    result,
    now,
});
export const reject = (ticket, error) => ({ type: 'reject', ticket, error });
export const retry = () => ({ type: 'retry' });
export const manualUp = () => ({ type: 'manualUp' });
export const liveTick = () => ({ type: 'liveTick' });
export const leadTick = () => ({ type: 'leadTick' });
export const resetCurrentSource = () => ({ type: 'resetCurrentSource' });
export const dispose = () => ({ type: 'dispose' });
//# sourceMappingURL=actions.js.map